export const FirebaseConfig = {
    apiKey: 'AIzaSyDV7GYYsg5pESC9yTNMZLlmGsmUoWm7Q-A',
    authDomain: 'kwaipwazjq.firebaseapp.com',
    projectId: 'kwaipwazjq',
    storageBucket: 'kwaipwazjq.appspot.com',
    messagingSenderId: '558015386050',
    appId: '1:558015386050:web:eaa812fe4cf65b1047c65b',
    measurementId: 'G-C36685GWCE',
};